// frontend/src/constants/timezones.js
//
// SINGLE SOURCE OF TRUTH for the timezone picker options.
//
// This list previously existed as a module-level `const TIMEZONE_OPTIONS`
// duplicated across six files (CompleteOwnerRegistration, FreelancerAccountForm,
// CompleteRegistrationPage, BoothRentalSignup, Locations, ShopDashboardPage).
// Because each copy was independent, editing one silently let the others drift,
// so a zone offered by one form could disagree with another. Import this module
// instead of declaring a local copy.
//
// The `label` text here is what a user sees on every signup and profile form,
// so changes are user-visible across the whole app.

// Worldwide timezone options grouped by region
export const TIMEZONE_OPTIONS = [
  // Americas
  { value: "America/New_York", label: "Eastern Time (US)" },
  { value: "America/Chicago", label: "Central Time (US)" },
  { value: "America/Denver", label: "Mountain Time (US)" },
  { value: "America/Los_Angeles", label: "Pacific Time (US)" },
  { value: "America/Phoenix", label: "Arizona (US)" },
  { value: "America/Anchorage", label: "Alaska (US)" },
  { value: "Pacific/Honolulu", label: "Hawaii (US)" },
  { value: "America/Toronto", label: "Toronto (Canada)" },
  { value: "America/Vancouver", label: "Vancouver (Canada)" },
  { value: "America/Mexico_City", label: "Mexico City" },
  { value: "America/Sao_Paulo", label: "São Paulo (Brazil)" },
  { value: "America/Buenos_Aires", label: "Buenos Aires (Argentina)" },
  { value: "America/Bogota", label: "Bogotá (Colombia)" },
  // Europe
  { value: "Europe/London", label: "London (UK)" },
  { value: "Europe/Paris", label: "Paris (France)" },
  { value: "Europe/Berlin", label: "Berlin (Germany)" },
  { value: "Europe/Madrid", label: "Madrid (Spain)" },
  { value: "Europe/Rome", label: "Rome (Italy)" },
  { value: "Europe/Amsterdam", label: "Amsterdam (Netherlands)" },
  { value: "Europe/Brussels", label: "Brussels (Belgium)" },
  { value: "Europe/Zurich", label: "Zurich (Switzerland)" },
  { value: "Europe/Stockholm", label: "Stockholm (Sweden)" },
  { value: "Europe/Warsaw", label: "Warsaw (Poland)" },
  { value: "Europe/Athens", label: "Athens (Greece)" },
  { value: "Europe/Moscow", label: "Moscow (Russia)" },
  // Middle East & Africa
  { value: "Asia/Dubai", label: "Dubai (UAE)" },
  { value: "Asia/Jerusalem", label: "Jerusalem (Israel)" },
  { value: "Asia/Riyadh", label: "Riyadh (Saudi Arabia)" },
  { value: "Africa/Cairo", label: "Cairo (Egypt)" },
  { value: "Africa/Lagos", label: "Lagos (Nigeria)" },
  { value: "Africa/Johannesburg", label: "Johannesburg (South Africa)" },
  { value: "Africa/Nairobi", label: "Nairobi (Kenya)" },
  // Asia & Pacific
  { value: "Asia/Kolkata", label: "India (IST)" },
  { value: "Asia/Singapore", label: "Singapore" },
  { value: "Asia/Hong_Kong", label: "Hong Kong" },
  { value: "Asia/Shanghai", label: "Shanghai (China)" },
  { value: "Asia/Tokyo", label: "Tokyo (Japan)" },
  { value: "Asia/Seoul", label: "Seoul (South Korea)" },
  { value: "Asia/Bangkok", label: "Bangkok (Thailand)" },
  { value: "Asia/Jakarta", label: "Jakarta (Indonesia)" },
  { value: "Asia/Manila", label: "Manila (Philippines)" },
  { value: "Australia/Sydney", label: "Sydney (Australia)" },
  { value: "Australia/Melbourne", label: "Melbourne (Australia)" },
  { value: "Australia/Perth", label: "Perth (Australia)" },
  { value: "Pacific/Auckland", label: "Auckland (New Zealand)" },
];
